"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.AccountQuotaMessage = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _Image = _interopRequireWildcard(require("../Image"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OAuthList = function OAuthList(_ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    _ref$numAccounts = _ref.numAccounts,
    numAccounts = _ref$numAccounts === void 0 ? 0 : _ref$numAccounts,
    message = _ref.message,
    children = _ref.children;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    alt: "OnMail",
    className: "w-32",
    src: (0, _Image.withThemeSrc)(t('onmail.png'), t('onmail-light.png'))
  }), /*#__PURE__*/_react["default"].createElement("h1", {
    className: "text-4xl font-bold text-dark my-3"
  }, t('retrofit.oauthList.header', {
    // If 0 total accounts, show singular, else plural
    count: numAccounts === 0 ? 1 : 2
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-lg text-light font-light"
  }, t('retrofit.oauthList.description')), message && /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-2"
  }, message), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-12"
  }, !isLoading ? children : /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], null)));
};
var AccountQuotaMessage = exports.AccountQuotaMessage = function AccountQuotaMessage(_ref2) {
  var count = _ref2.count,
    maxCount = _ref2.maxCount,
    _ref2$isPremium = _ref2.isPremium,
    isPremium = _ref2$isPremium === void 0 ? false : _ref2$isPremium;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var isExceeded = count === maxCount;
  var message = (0, _react.useMemo)(function () {
    if (!isPremium) {
      return t('retrofit.quota.exceeded.free');
    } else if (isExceeded) {
      return t('retrofit.quota.exceeded', {
        count: count,
        maxCount: maxCount
      });
    } else {
      return t('retrofit.quota.message', {
        count: count,
        maxCount: maxCount
      });
    }
  }, [isExceeded, count, maxCount, isPremium]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('text-sm italic', {
      'text-red': isExceeded
    })
  }, message);
};
var _default = exports["default"] = OAuthList;
//# sourceMappingURL=OAuthList.js.map